module.exports = __webpack_public_path__ + "static/media/contact-red.e331f9a4.svg";